import { MUTATION_TYPES } from './types';
import { initialState } from './state'; //Import initial state object for reset when was destroy

export const mutations = {
  [MUTATION_TYPES.RESET](state) {
    Object.assign(state, initialState());
  },
};
